<template>
  <svg width="20"
       height="22"
       viewBox="0 0 20 22"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5263 21.6666H1.47301C1.32418 21.6675 1.17663 21.6391 1.03879 21.5829C0.900951 21.5268 0.775521 21.444 0.669662 21.3394C0.563803 21.2348 0.479587 21.1103 0.421824 20.9732C0.364061 20.836 0.333881 20.6888 0.333008 20.54V3.45997C0.336965 3.29505 0.37585 3.13285 0.447098 2.98407C0.518346 2.83529 0.620337 2.7033 0.746339 2.59683C0.872341 2.49036 1.01949 2.41182 1.17808 2.36639C1.33666 2.32097 1.50308 2.30969 1.66634 2.3333H2.99967V3.66664H1.66634V20.3333H16.333V3.66664H14.9997V2.3333H16.4997C16.6507 2.32886 16.8011 2.35466 16.9421 2.40921C17.083 2.46375 17.2116 2.54593 17.3203 2.6509C17.429 2.75588 17.5156 2.88154 17.5751 3.02048C17.6345 3.15943 17.6655 3.30885 17.6663 3.45997V20.54C17.6655 20.6888 17.6353 20.836 17.5775 20.9732C17.5198 21.1103 17.4355 21.2348 17.3297 21.3394C17.2238 21.444 17.0984 21.5268 16.9606 21.5829C16.8227 21.6391 16.6752 21.6675 16.5263 21.6666Z"
      fill="url(#paint0_linear_155_2301)" />
    <path
      d="M14.3337 6.33335H3.66699V3.88669C3.66875 3.47526 3.83296 3.08118 4.12389 2.79025C4.41482 2.49933 4.8089 2.33511 5.22033 2.33335H6.41366C6.56053 1.75974 6.89413 1.25133 7.36187 0.888261C7.82961 0.525193 8.40488 0.328125 8.99699 0.328125C9.58911 0.328125 10.1644 0.525193 10.6321 0.888261C11.0999 1.25133 11.4335 1.75974 11.5803 2.33335H12.7737C13.1862 2.33335 13.582 2.49679 13.8744 2.78791C14.1668 3.07902 14.3319 3.47411 14.3337 3.88669V6.33335ZM5.00033 5.00002H13.0003V3.88669C13.0003 3.82834 12.9771 3.77238 12.9359 3.73112C12.8946 3.68987 12.8387 3.66669 12.7803 3.66669H10.3337V3.00002C10.3337 2.6464 10.1932 2.30726 9.94313 2.05721C9.69309 1.80716 9.35395 1.66669 9.00033 1.66669C8.6467 1.66669 8.30757 1.80716 8.05752 2.05721C7.80747 2.30726 7.66699 2.6464 7.66699 3.00002V3.66669H5.22033C5.19143 3.66669 5.16283 3.67238 5.13614 3.68343C5.10944 3.69449 5.08519 3.71069 5.06476 3.73112C5.04433 3.75155 5.02813 3.7758 5.01707 3.8025C5.00602 3.82919 5.00033 3.8578 5.00033 3.88669V5.00002Z"
      fill="url(#paint0_linear_155_2301)" />

    <defs>
      <linearGradient id="paint0_linear_155_2301"
                      x1="13.3333"
                      y1="0"
                      x2="13.3333"
                      y2="26.6667"
                      gradientUnits="userSpaceOnUse">
        <stop :stop-color="active ? `${$store.state.ui_options.theme?.selected_item_color || '#59BEE5'}` : color" />
        <stop offset="1" :stop-color="active ? `${$store.state.ui_options.theme?.selected_item_color || '#118EBE'}` : color" />
      </linearGradient>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "#899399"
    }
  }
}
</script>
